const tagListDB: myTag[] = [
  {id: 0, type: '-', iconName: 'shuiguo', text: '水果'},
  {id: 0, type: '-', iconName: 'shuidianmei', text: '水电'},
  {id: 0, type: '-', iconName: 'xinyongkahuankuan', text: '信用卡还款'},
  {id: 0, type: '-', iconName: 'fangzu', text: '房租'},
  {id: 0, type: '-', iconName: 'lifa2', text: '理发'},
  {id: 0, type: '-', iconName: 'huafei', text: '话费'},
  {id: 0, type: '-', iconName: 'fushi', text: '服饰'},
  {id: 0, type: '-', iconName: 'canyinye', text: '餐饮'},
  {id: 0, type: '-', iconName: 'yule', text: '娱乐'},
  {id: 0, type: '-', iconName: 'movie', text: '看电影'},
  {id: 0, type: '-', iconName: 'drink', text: '饮料'},
  {id: 0, type: '-', iconName: 'jiaotong', text: '交通'},
  {id: 0, type: '-', iconName: 'youxi', text: '游戏'},
  {id: 0, type: '-', iconName: 'vegetables', text: '买菜'},
  {id: 0, type: '-', iconName: 'jingdong', text: '京东购物'},
  {id: 0, type: '-', iconName: 'taobao', text: '淘宝购物'},
  {id: 0, type: '+', iconName: 'hongbao', text: '红包'},
  {id: 0, type: '+', iconName: 'gupiao', text: '股票'},
  {id: 0, type: '+', iconName: 'jijin', text: '基金'},
  {id: 0, type: '+', iconName: 'jianzhi', text: '兼职'},
  {id: 0, type: '+', iconName: 'tuikuan', text: '退款'},
  {id: 0, type: '-', iconName: 'lingshi', text: '零食'},
  {id: 0, type: '-', iconName: 'chaoshi', text: '超市'},
];
export default tagListDB;